import { useEffect, useState, type ReactNode } from 'react';
import { publicMetaCdnUrl } from '@/lib/social/metaCdnHost';

interface SocialAvatarProps {
  src?: string | null;
  alt?: string;
  className?: string;
  fallback: ReactNode;
  loading?: 'lazy' | 'eager';
}

export function SocialAvatar({
  src,
  alt = '',
  className,
  fallback,
  loading = 'lazy',
}: SocialAvatarProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const usable = typeof src === 'string' && src.trim().length > 0;
  if (!usable || failed) return <>{fallback}</>;

  const href = publicMetaCdnUrl(src as string);

  return (
    <img
      src={href}
      alt={alt}
      className={className}
      loading={loading}
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
    />
  );
}
